import {
  CreateBase,
  Form,
  useDataProvider,
  useGetIdentity,
  useNotify,
  useTranslate,
  type Identifier,
} from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { CancelButton } from "@/components/admin/cancel-button";
import { SaveButton } from "@/components/admin/form";

import {
  assertCompanyIsUnique,
  DuplicateRecordError,
} from "@/lib/duplicateIdentity";
import { CompanyInputs } from "./CompanyInputs";

export const CompanyCreate = () => {
  const { identity } = useGetIdentity();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const translate = useTranslate();
  return (
    <CreateBase
      redirect="show"
      transform={async (values: {
        website?: string;
        name?: string;
        id?: Identifier;
      }) => {
        if (values.website && !values.website.startsWith("http")) {
          values.website = `https://${values.website}`;
        }
        try {
          await assertCompanyIsUnique(dataProvider, {
            id: values.id,
            name: values.name,
          });
        } catch (error) {
          if (error instanceof DuplicateRecordError) {
            notify(error.message, { type: "warning" });
          }
          throw error;
        }
        return values;
      }}
    >
      <div className="mt-2 flex lg:mr-72">
        <div className="flex-1">
          <Form defaultValues={{ sales_id: identity?.id }}>
            <Card>
              <CardContent>
                <CompanyInputs />
                <div
                  role="toolbar"
                  className="sticky flex pt-4 pb-4 md:pb-0 bottom-0 bg-linear-to-b from-transparent to-card to-10% flex-row justify-end gap-2"
                >
                  <CancelButton />
                  <SaveButton
                    label={translate("resources.companies.action.create", {
                      _: "Create Company",
                    })}
                  />
                </div>
              </CardContent>
            </Card>
          </Form>
        </div>
      </div>
    </CreateBase>
  );
};
